import { initializeApp } from "firebase/app"

import config from "./config"

const firebaseApp = initializeApp(config.firebase)
console.log("Initializing Firebase instance")

export default firebaseApp
